import React from 'react';
import { useLocation } from 'react-router-dom';
import SideBar from '../Components/Sidebar/panalSidebar';
const SideLayout = ({ children }) => {
  const location = useLocation();
  const isSidebarEnabled = location.pathname.startsWith('/Integration');
  
  return (
    <div className="sidebar-layout">
      <div className={`sidebar ${isSidebarEnabled ? 'fixed-lefty' : ''}`}>
         <SideBar currentPath={location.pathname} />
      </div>
      <main className="main-content">{children}</main>
    </div>
  )
}

export default SideLayout;